import React, { useState, useEffect } from "react";
import axios from "axios"
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Stack from "react-bootstrap/Stack";
import { Divider, Button, Loader } from "semantic-ui-react";
import { FaNewspaper } from "react-icons/fa";
import { slugify } from "./utility";

export const Blog = (search = null) => {
    const navigate = useNavigate()
    const [dataArticle, setDataArticle] = useState([])
    const [loadData, setLoadData] = useState(false)
    // const [search, setSearch] = useState("")

    const handleClickBlog = (data) => { 
        //console.log(data)
        const slug = slugify(data.title)
        // navigate(`/article/${data.id}/${slug}`, { state: data })
        navigate(`/article/${slug}`, {
            state: data
        });
    }

    const handleClickLoadMore = () => {
        navigate(`/blog`, { state: dataArticle })
    }

    const getArticle = async () => {
        if (loadData) return;
        setLoadData(true)
        const url = process.env.REACT_APP_BLOG_URL
        await axios({
            method: "GET",
            url: url,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit: 4,
                ...search
            }
        }).then(res => {
            if (res.data.state === 200) {
                setDataArticle(res.data.data)
            } else {
                alert(res.data.message)
            }
        }).finally(() => setLoadData(false))
    }

    useEffect(() => {
        getArticle()
    }, [search])

    const renderContent = () => {
        if (loadData) {
            return (
                <Row className="d-flex justify-content-center">
                    <Col sm={12} className="text-center">
                        <Loader active inline size="small" />
                    </Col>
                </Row>
            );
        }

        if (dataArticle.length > 0) {
            return (
                <>
                    <Row className="d-flex justify-content-start">
                        {dataArticle.map((item, i) => (
                            <Col xl={3} lg={4} md={6} sm={12} className="mb-4" key={i} style={{ cursor: "pointer" }}>
                                <div onClick={() => handleClickBlog(item)}>
                                    <Image src={item.image_thumbnail} width="100%" height={200} rounded />
                                    <h3 className="mt-2">{item.title}</h3>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col xl={6} lg={12} md={12} className="text-center">
                            <Button
                                content="More Article"
                                basic
                                color="black"
                                icon="refresh"
                                onClick={handleClickLoadMore}
                            />
                        </Col>
                    </Row>
                </>
            );
        }

        return (
            <Row className="d-flex justify-content-center">
                <Col sm={12} className="text-center">
                    No Article Has Found
                </Col>
            </Row>
        );
    };

    return (
        search !== null && search.search !== undefined && (
            <Container>
                <Row className="mb-3">
                    <Col md={12} className="text-start">
                        <div className="text-center fs-2"><FaNewspaper /></div>
                        <Divider horizontal><h1 className="fs-6">Latest News & Article</h1></Divider>
                    </Col>
                </Row>
                <div className="pb-3">
                    {renderContent()}
                </div>
                <hr />
            </Container>
        )
    )
}